<template>
  <div class="upload">
    <div class="upload_warp" @click="fileClick" @drop="drop($event)" @dragenter="dragenter($event)" @dragover="dragover($event)">
      <div class="upload_btn" v-show="imgList.length===0">
        <v-icon x-large color="primary" style="margin-top: 20px">inbox</v-icon>
        <v-btn text style="margin-top: 10px" :color="messageColor">
          {{ message }}
        </v-btn>
      </div>
      <div class="upload_warp_img" style="display: flex;justify-content: center" v-show="imgList.length!==0">
        <div class="upload_warp_img_div" v-for="(item, index) of imgList" :key="index">
          <div class="upload_warp_img_div_top">
            <div class="upload_warp_img_div_text">
              {{item.file.name}}
            </div>
            <v-icon class="upload_warp_img_div_del" @click.stop="fileDel(index)">close</v-icon>
          </div>
          <img :src="item.file.src">
        </div>
      </div>
    </div>
    <div class="upload_warp_text">
      <v-btn text x-small>
        Select {{imgList.length}} files ，total {{bytesToSize(this.size)}}
      </v-btn>
    </div>
    <input @change="fileChange($event)" type="file" id="upload_file" multiple style="display: none"/>
  </div>
</template>

<script>
export default {
  name: 'FilesUpload',
  props: {
    type: String,
    number: Number
  },
  data () {
    return {
      imgList: [],
      size: 0,
      message: 'Drag the file here,Upload one at a time.',
      messageColor: ''
    }
  },
  methods: {
    fileClick () {
      document.getElementById('upload_file').click()
    },
    fileChange (el) {
      if (!el.target.files[0].size) return
      this.fileList(el.target)
      el.target.value = ''
    },
    fileList (fileList) {
      const files = fileList.files
      for (let i = 0; i < files.length; i++) {
        if (files[i].type !== '') {
          this.fileAdd(files[i])
        } else {
          this.folders(fileList.items[i])
        }
      }
    },
    folders (files) {
      const _this = this
      if (files.kind) {
        files = files.webkitGetAsEntry()
      }
      files.createReader().readEntries(function (file) {
        for (let i = 0; i < file.length; i++) {
          if (file[i].isFile) {
            _this.foldersAdd(file[i])
          } else {
            _this.folders(file[i])
          }
        }
      })
    },
    foldersAdd (entry) {
      const _this = this
      entry.file(function (file) {
        _this.fileAdd(file)
      })
    },
    fileAdd (file) {
      if (file.name.includes('csv') || file.name.includes('xls') || file.name.includes('xlsx')) {
        this.messageColor = ''
        this.message = 'Drag the file here,Upload one at a time.'
        if (this.imgList.length > 0 && this.type === 'single') {
          this.popSweetAlert('warning', 'Only one file can be uploaded')
        } else {
          this.size = this.size + file.size
          if (file.type.indexOf('image') === -1) {
            this.imgList.push({
              file
            })
          } else {
            const reader = new FileReader()
            reader.vue = this
            reader.readAsDataURL(file)
            reader.onload = function () {
              file.src = this.result
              this.vue.imgList.push({
                file
              })
            }
          }
        }
      } else {
        this.messageColor = 'error'
        this.message = 'Support CSV or XLS or XLSX files'
      }
    },
    fileDel (index) {
      this.size = this.size - this.imgList[index].file.size
      this.imgList.splice(index, 1)
    },
    bytesToSize (bytes) {
      if (bytes === 0) return '0 B'
      const k = 1000 // or 1024
      const sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
      const i = Math.floor(Math.log(bytes) / Math.log(k))
      return (bytes / Math.pow(k, i)).toPrecision(3) + ' ' + sizes[i]
    },
    dragenter (el) {
      el.stopPropagation()
      el.preventDefault()
    },
    dragover (el) {
      el.stopPropagation()
      el.preventDefault()
    },
    drop (el) {
      el.stopPropagation()
      el.preventDefault()
      this.fileList(el.dataTransfer)
    },
    saveFile () {
      return this.imgList
    },
    clearFile () {
      this.imgList = []
    },
    popSweetAlert (type, tips) {
      this.$swal({
        type: type,
        text: tips,
        showCancelButton: false
      })
    }
  },
  created () {
    this.imgList = []
  }
}
</script>

<style scoped>
  .upload:hover {
    border: 1px dashed #229db7;
  }
  .upload_btn {
    display: flex;
    justify-content: center;
    flex-direction: column;
  }
  .upload_warp_img_div_del {
    position: absolute;
    top: 6px;
    width: 16px;
    right: 4px;
  }

  .upload_warp_img_div_top {
    position: absolute;
    top: 0;
    width: 100%;
    height: 30px;
    background-color: rgba(0, 0, 0, 0.4);
    line-height: 30px;
    text-align: left;
    color: #fff;
    font-size: 12px;
    text-indent: 4px;
  }

  .upload_warp_img_div_text {
    white-space: nowrap;
    width: 80%;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .upload_warp_img_div img {
    max-width: 100%;
    max-height: 100%;
    vertical-align: middle;
  }

  .upload_warp_img_div {
    position: relative;
    height: 100px;
    width: 120px;
    border: 1px dashed #ccc;
    margin: 0px 30px 10px 0px;
    float: left;
    line-height: 100px;
    display: table-cell;
    text-align: center;
    background-color: #eee;
    cursor: pointer;
  }

  .upload_warp_img {
    border-top: 1px dashed #D2D2D2;
    padding: 14px 0 0 14px;
    overflow: hidden
  }

  .upload_warp_text {
    text-align: center;
    margin-bottom: 10px;
    padding-top: 10px;
    text-indent: 14px;
    border-top: 1px dashed #ccc;
    font-size: 14px;
  }

  .upload_warp_left img {
    margin-top: 32px;
  }

  .upload_warp {
    height: 130px;
    cursor: pointer;
    background-color: rgba(204, 204, 204, 0.63);
  }

  .upload {
    border: 1px dashed #ccc;
    background-color: #fff;
    width: 100%;
    margin: auto;
    box-shadow: 0px 1px 0px #ccc;
    border-radius: 4px;
  }
</style>
